import React, { useCallback, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import {
  Collapse,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import useStore from '../../states/store';
import AppConst from './const';

export default function MenuItemCollapse({ item, toggleDrawer, onChangePage }) {
  /* test */
  /* test */
  const auth = useStore((state) => state.auth);
  const { onToggleModal } = useContext(AppConst.AppContext);
  const [open, setOpen] = useState(false);

  const handleClick = () => setOpen(!open);
  const handleToggleDrawer = useCallback(() => toggleDrawer());

  return (
    <>
      <ListItemButton onClick={handleClick}>
        <ListItemIcon>{item.icon}</ListItemIcon>
        <ListItemText primary={item.title} />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={open} timeout='auto' unmountOnExit>
        <List component='div' disablePadding>
          {item.child.map((row) => {
            if (row?.permissions?.includes(auth.designation)) {
              if (row?.type === 'modal') {
                return (
                  <ListItem
                    button
                    to={row.url}
                    key={row.slug}
                    onClick={() => {
                      onToggleModal(row);
                      handleToggleDrawer();
                      onChangePage(); /* test */
                    }}
                    sx={{ pl: 4 }}
                  >
                    <ListItemIcon>{row.icon}</ListItemIcon>
                    <ListItemText primary={`${row.title}`} />
                  </ListItem>
                );
              }
              return (
                <ListItem
                  button
                  component={Link}
                  to={row.url}
                  key={row.slug}
                  onClick={onChangePage} /* test */
                  sx={{ pl: 4 }}
                >
                  <ListItemIcon>{row.icon}</ListItemIcon>
                  <ListItemText primary={`${row.title}`} />
                </ListItem>
              );
            }
            return '';
          })}
        </List>
      </Collapse>
    </>
  );
}

const itemShape = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
};

MenuItemCollapse.defaultProps = {
  toggleDrawer: () => {},
  onChangePage: () => {} /* test */,
};
MenuItemCollapse.propTypes = {
  item: PropTypes.shape({
    icon: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    child: PropTypes.arrayOf(PropTypes.shape(itemShape)),
  }).isRequired,
  toggleDrawer: PropTypes.func,
  onChangePage: PropTypes.func /* test */,
};
